var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 0H2.75C1.2332 0 0 1.2332 0 2.75V15.125C0 16.6418 1.2332 17.875 2.75 17.875H6.875V21.4844C6.875 21.7895 7.12422 22 7.39062 22C7.49375 22 7.60117 21.9699 7.6957 21.8969L13.0625 17.875H19.25C20.7668 17.875 22 16.6418 22 15.125V2.75C22 1.2332 20.7668 0 19.25 0ZM19.9375 15.125C19.9375 15.5031 19.6281 15.8125 19.25 15.8125H12.375L11.825 16.225L8.9375 18.3906V15.8125H2.75C2.37188 15.8125 2.0625 15.5031 2.0625 15.125V2.75C2.0625 2.37188 2.37188 2.0625 2.75 2.0625H19.25C19.6281 2.0625 19.9375 2.37188 19.9375 2.75V15.125Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.cdeb392e4d04f26dc0f80411a31b21b5.svg";
export { ForwardRef as ReactComponent };